import styled from 'styled-components';
import { TimeTickerProps } from './TimeTicker';

export const StyledTimeTicker = styled.div<TimeTickerProps>`
  position: absolute;
  width: 1.5px;
  height: ${(props: TimeTickerProps) => props.height}px;
  top: ${(props) => props.top}px;
  right: 0;
  background-color: #3239fe;

  .svgTop {
    position: absolute;
    left: -6.35px;
    top: -1px;
  }

  .svgBottom {
    position: absolute;
    left: -6.35px;
    bottom: -1px;
  }
`;
